import {
  CloudflareDnsResponseSchema,
  CloudflareDnsResponse,
} from '@/services/userbeat/types';

export async function resolveUserBeatUrl(): Promise<string | null> {
  const dnsHttps = await fetch(
    'https://cloudflare-dns.com/dns-query?name=userbeat.e2n.dev&type=CNAME',
    {
      headers: { accept: 'application/dns-json' },
    },
  );

  const raw = await dnsHttps.json();
  const parsed = CloudflareDnsResponseSchema.safeParse(raw);
  if (!parsed.success) return null;

  const dnsData: CloudflareDnsResponse = parsed.data;
  const cname = dnsData.Answer?.[0]?.data;
  if (!cname) return null;

  return cname.endsWith('.') ? cname.slice(0, -1) : cname;
}
